import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
  hideheader = false;
  hidelegal = false;
}
